export const setUrlParams = (setSearchParams, key, value) => {
  setSearchParams(() => {
    // ✅ Get all existing URL params (direct from the URL)
    const existingParams = getAllUrlParams();

    // ✅ Merge existing params with the new key-value pair
    const updatedParams = {
      ...existingParams,
      [key]: value,
    };

    // ✅ Update localStorage with all params
    localStorage.setItem("urlParams", JSON.stringify(updatedParams));

    // ✅ Return updated params to setSearchParams
    return new URLSearchParams(updatedParams);
  });
};

export const getUrlParams = (key) => {
  const savedFilters = localStorage.getItem("urlParams");
  const params = new URLSearchParams(window.location.search);

  const value =
    params.get(key) || (savedFilters ? JSON.parse(savedFilters)[key] : null);

  // Ensure the URL gets updated if the param exists in localStorage but not in the URL
  if (!params.get(key) && value) {
    const newParams = new URLSearchParams(window.location.search);
    newParams.set(key, value);
    window.history.replaceState(null, "", `?${newParams.toString()}`);
  }

  return value;
};

export const getAllUrlParams = () => {
  const savedFilters = localStorage.getItem("urlParams");
  const params = new URLSearchParams(window.location.search);
  return savedFilters
    ? { ...JSON.parse(savedFilters), ...Object.fromEntries(params) }
    : Object.fromEntries(params);
};

export const getNavigationUrl = (modulePath) => {
  const allParams = getAllUrlParams();
  const queryString = new URLSearchParams(allParams).toString();
  return `${modulePath}${queryString ? `?${queryString}` : ""}`;
};
